<script setup>
import { ref } from 'vue'
import { truncateText } from '../helpers.js'

defineProps({
  requirementsSummary: { type: String, required: true },
  items: { type: Array, default: () => [] }
})

const emit = defineEmits(['item-click', 'title-click'])

const isExpanded = ref(true)

function toggleExpanded() {
  isExpanded.value = !isExpanded.value
}

function handleItemClick(item) {
  emit('item-click', item)
}

function handleTitleClick(item) {
  emit('title-click', item)
}
</script>

<template>
  <div>
    <div class="mb-3">
      <div
        class="d-flex justify-content-between align-items-center list-header"
        role="button"
        @click="toggleExpanded"
      >
        <p id="requirementsSummary" class="fw-bold text-16 text-primary mb-0">{{ requirementsSummary }}</p>
        <i
          class="bi text-primary"
          :class="isExpanded ? 'bi-caret-up-fill' : 'bi-caret-down-fill'"
        ></i>
      </div>
      <p v-if="isExpanded" id="requirementsSummaryDescription" class="text-16 text-muted mt-3">
        Take action on any items that still require attention. Click a requirement to view the
        questions needed to complete it, along with the employer’s projected reduction in compliance
        risk and potential cost exposure.
      </p>
    </div>

    <ul v-if="isExpanded" class="list-unstyled mb-0">
      <li
        v-for="(item, index) in items"
        :key="`${item.questionId}-${item.arrayIndex ?? index}`"
        class="d-flex justify-content-between align-items-center py-1.5 border-top"
      >
        <div class="text-14 text-primary flex-grow-1 ps-3">
          <button
            :id="`markCompleteTitle-${item.questionId}`"
            class="btn btn-link p-0 text-decoration-none text-primary text-start w-100"
            type="button"
            @click="handleTitleClick(item)"
          >
            {{ truncateText(item.actionCenterTitle || item.title || item.body) }}
          </button>
        </div>
        <div
          :id="`markCompleteBtn-${item.questionId}`"
          class="text-16 fw-bold text-primary mark-complete-label pe-4"
          role="button"
          @click="handleItemClick(item)"
        >
          <strong>Mark Complete  </strong> 
          <i class="bi bi-chevron-right ms-1"></i>
        </div>
      </li>
    </ul>
  </div>
</template>

<style scoped lang="scss">
.list-header {
  cursor: pointer;
}

.mark-complete-label {
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  
  &:hover {
    text-decoration: underline;
  }
}

.action-button {
  padding-left: 1.5rem;
}
</style>
